module.exports = __webpack_public_path__ + "static/media/paserg-border-leaves.a15cb150.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/paserg/paserg-border-leaves.png
// module id = 212
// module chunks = 0